// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3m6ze","search":"Settings_search__1zMTI","filter":"Settings_filter__3Qw0Q"};